// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Encounters list only. Namespaced so Dashboard / Patients / Appointments / Chart stay unchanged. */

.emr-enc,
.emr-enc *,
.emr-enc *::before,
.emr-enc *::after,
.emr-enc-select,
.emr-enc-select *,
.emr-enc-dialog,
.emr-enc-dialog * {
  border-radius: 0 !important;
}

.emr-enc {
  --emr-enc-primary: #1976d2;
  --emr-enc-primary-dark: #0d47a1;
  --emr-enc-text: #212121;
  --emr-enc-muted: #616161;
  --emr-enc-border: #e0e0e0;
  --emr-enc-surface: #ffffff;
  max-width: none;
  margin: 0;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  color: var(--emr-enc-text);
  /* Arial is declared here rather than left to inherit from the Materialize
     overlay, so this section owns its own family. */
  font-family: var(--emr-font-sans);
  font-size: 16px;
}

.emr-enc__pagehead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.emr-mz-dashboard .emr-enc__title,
.emr-enc__title {
  margin: 0;
  font-size: var(--emr-type-page-title) !important;
  font-weight: 600;
  line-height: 1.25;
  color: var(--emr-enc-text);
}

.emr-enc__subtitle {
  margin: 2px 0 0;
  font-size: var(--emr-type-helper);
  font-weight: 400;
  color: var(--emr-enc-muted);
}

.emr-mz-dashboard .btn.emr-enc__register {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 14px;
  margin: 0;
  flex-shrink: 0;
  background: var(--emr-enc-primary);
  border-radius: 0;
  box-shadow: none;
}

.emr-mz-dashboard .btn.emr-enc__register:hover,
.emr-mz-dashboard .btn.emr-enc__register:focus {
  background: var(--emr-enc-primary-dark);
}

.emr-enc__register-icon {
  width: 16px;
  height: 16px;
}

.emr-enc__filter {
  max-width: 320px;
  width: 100%;
  min-width: 0;
  margin-bottom: 6px;
}

.emr-mz-dashboard .emr-enc__filter-trigger,
.emr-enc__filter-trigger {
  height: 40px !important;
  min-height: 40px !important;
  width: 100% !important;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box !important;
  border: 1px solid var(--emr-enc-border) !important;
  border-radius: 0 !important;
  background: var(--emr-enc-surface) !important;
  box-shadow: none !important;
  font-size: var(--emr-type-body) !important;
  font-weight: 400 !important;
}

.emr-mz-dashboard .emr-enc__filter-trigger:focus,
.emr-enc__filter-trigger:focus {
  border: 1px solid var(--emr-enc-primary) !important;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.18) !important;
  outline: none;
}

.emr-enc-select {
  border-radius: 0 !important;
  border: 1px solid var(--emr-enc-border, #e0e0e0) !important;
  background: #fff !important;
  box-shadow: none !important;
}

.emr-enc__panel {
  margin-bottom: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  background: var(--emr-enc-surface);
  border: 1px solid var(--emr-enc-border);
  box-shadow: none;
}

.emr-enc__status-msg,
.emr-enc__empty {
  padding: 28px 16px;
  text-align: center;
  font-size: 16px;
  color: var(--emr-enc-muted);
}

.emr-enc__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.emr-enc__empty-icon {
  width: 32px;
  height: 32px;
  color: #bdbdbd;
}

.emr-enc__table-wrap {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.emr-mz-dashboard table.emr-enc__table,
.emr-enc__table {
  display: table;
  width: 100%;
  min-width: 860px;
  border-collapse: collapse;
  position: static;
  font-family: var(--emr-font-sans);
  font-size: 16px;
  line-height: 16px;
}

.emr-mz-dashboard table.emr-enc__table thead,
.emr-mz-dashboard table.emr-enc__table tbody {
  display: table-header-group;
  position: static;
  float: none;
  overflow: visible;
  width: auto;
}

.emr-mz-dashboard table.emr-enc__table tbody {
  display: table-row-group;
}

.emr-mz-dashboard table.emr-enc__table tr {
  display: table-row;
}

/*
 * Row geometry lives here on purpose. This selector is (0,2,2) and therefore
 * outranks the \`.emr-mz-dashboard .emr-enc__table td\` rule below at (0,2,1),
 * so vertical padding and line-height set further down would lose. It also
 * clears Materialize's \`.emr-mz-dashboard td, th { padding: 15px 5px }\` (0,1,1)
 * without !important.
 *
 * Same accepted clinical density as the patient-chart tables: Arial, 16px text
 * on a 16px line, 20px data rows, 2px vertical cell padding. The 12px
 * horizontal gutter is kept from the existing design — this table declares
 * min-width 860px across seven columns and scrolls, so narrowing the gutter
 * would only crowd the columns.
 */
.emr-mz-dashboard table.emr-enc__table th,
.emr-mz-dashboard table.emr-enc__table td {
  display: table-cell;
  box-sizing: border-box;
  height: 20px;
  max-height: 20px;
  padding-top: 2px;
  padding-bottom: 2px;
  font-family: var(--emr-font-sans);
  font-size: 16px;
  line-height: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.emr-mz-dashboard .emr-enc__table th {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--emr-enc-muted);
  padding: 2px 12px;
  line-height: 16px;
  border-bottom: 1px solid var(--emr-enc-border);
  background: #fafbfc;
  white-space: nowrap;
}

.emr-mz-dashboard .emr-enc__table td {
  font-size: 16px;
  font-weight: 400;
  padding: 2px 12px;
  line-height: 16px;
  color: var(--emr-enc-text);
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
}

.emr-enc__actions-col {
  text-align: right;
}

/* A 20px row leaves a 16px content box once 2px + 2px cell padding is taken,
   so every in-row chip and action button is sized to exactly 16px. */
.emr-mz-dashboard a.emr-enc__number,
.emr-enc__number {
  display: inline-flex;
  align-items: center;
  height: 16px;
  padding: 0 8px;
  background: #0b1f33 !important;
  color: #90caf9 !important;
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-decoration: none;
}

.emr-mz-dashboard a.emr-enc__number:hover,
.emr-enc__number:hover {
  background: var(--emr-enc-primary-dark) !important;
  color: #fff !important;
}

.emr-enc__patient {
  font-weight: 600;
}

/* The start datetime is table data, not chrome, so it takes the 16px standard
   rather than the metadata band it used before. */
.emr-enc__start {
  font-size: 16px;
  line-height: 16px;
  color: var(--emr-enc-muted);
  white-space: nowrap;
}

/* The DEMO flag keeps --emr-type-micro: emr-typography.css reserves sub-12px
   for exactly this kind of incidental chrome ("rulers, demo-data flags"). Only
   its box shrinks, so it fits the 16px content box. */
.emr-enc__demo {
  display: inline-flex;
  align-items: center;
  height: 16px;
  margin-left: 8px;
  padding: 0 6px;
  background: #fff8e1;
  color: #f9a825;
  font-size: var(--emr-type-micro);
  font-weight: 700;
  letter-spacing: 0.06em;
  vertical-align: middle;
}

.emr-enc__status {
  display: inline-flex;
  align-items: center;
  height: 16px;
  padding: 0 8px;
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: capitalize;
  white-space: nowrap;
}

.emr-enc__status--planned {
  background: #e3f2fd;
  color: #1565c0;
}

.emr-enc__status--arrived {
  background: #e8eaf6;
  color: #3949ab;
}

.emr-enc__status--triaged {
  background: #ede7f6;
  color: #5e35b1;
}

.emr-enc__status--in-progress {
  background: #fff8e1;
  color: #f9a825;
}

.emr-enc__status--onleave {
  background: #fff3e0;
  color: #ef6c00;
}

.emr-enc__status--finished {
  background: #e8f5e9;
  color: #2e7d32;
}

.emr-enc__status--cancelled {
  background: #eceff1;
  color: #546e7a;
}

.emr-enc__row-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2px;
  height: 16px;
}

/*
 * EncounterReadOnlyHint wraps the Edit button in two spans. The inner one is a
 * block containing an inline-flex button, so it builds a line box ~19px tall
 * and would push the row past 20px even though the button itself is 16px.
 * Collapsing the wrappers onto the button keeps the row at the standard without
 * touching the shared hint component.
 */
.emr-enc__row-actions > span,
.emr-enc__row-actions > span > span {
  display: inline-flex;
  align-items: center;
  height: 16px;
}

/* 16x16px in-row action buttons, matching the accepted Past Surgical History /
   Problem List / Allergies tables. The lucide icons inside are h-4 w-4, so they
   fill the button exactly. The !important flags here are pre-existing: they
   clear Materialize's own .btn sizing, not our own cascade. */
.emr-mz-dashboard .emr-enc-icon-btn {
  width: 16px !important;
  height: 16px !important;
  min-width: 16px !important;
  min-height: 16px !important;
  padding: 0 !important;
  line-height: 1 !important;
  border-radius: 0 !important;
  color: var(--emr-enc-primary);
}

.emr-mz-dashboard .emr-enc-icon-btn--danger {
  color: #d32f2f;
}

.emr-enc-dialog {
  border-radius: 0 !important;
  border: 1px solid var(--emr-enc-border, #e0e0e0);
  background: #fff !important;
  box-shadow: none;
}

.emr-enc-dialog__delete {
  background: #d32f2f !important;
  border-radius: 0 !important;
}

@media only screen and (max-width: 899px) {
  .emr-enc__pagehead {
    flex-wrap: wrap;
  }
}

@media only screen and (max-width: 1023px) {
  .emr-enc__table-wrap {
    overflow-x: auto;
  }
}

@media only screen and (max-width: 600px) {
  .emr-enc__pagehead {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    margin-bottom: 6px;
  }

  .emr-mz-dashboard .emr-enc__title,
  .emr-enc__title {
    font-size: var(--emr-type-page-title-compact) !important;
  }

  .emr-mz-dashboard .btn.emr-enc__register {
    width: 100%;
    justify-content: center;
  }

  .emr-enc__filter {
    max-width: 100%;
  }

  .emr-mz-dashboard .emr-enc__table th,
  .emr-mz-dashboard .emr-enc__table td {
    padding: 2px 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-encounters.css"],"names":[],"mappings":"AAAA,oGAAoG;;AAEpG;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,SAAS;EACT,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B;oDACkD;EAClD,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,gDAAgD;EAChD,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,kDAAkD;EAClD,2BAA2B;EAC3B,6CAA6C;EAC7C,2BAA2B;EAC3B,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;;EAEE,mDAAmD;EACnD,yDAAyD;EACzD,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,2DAA2D;EAC3D,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;EAYE;AACF;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;EACjB,8CAA8C;EAC9C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;qEACqE;AACrE;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;EAEE,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;kDACkD;AAClD;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;sDAEsD;AACtD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,YAAY;AACd;;AAEA;;;;;;EAME;AACF;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;8DAG8D;AAC9D;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;EAChD,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;;IAEE,wDAAwD;EAC1D;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;AACF","sourcesContent":["/* Encounters list only. Namespaced so Dashboard / Patients / Appointments / Chart stay unchanged. */\n\n.emr-enc,\n.emr-enc *,\n.emr-enc *::before,\n.emr-enc *::after,\n.emr-enc-select,\n.emr-enc-select *,\n.emr-enc-dialog,\n.emr-enc-dialog * {\n  border-radius: 0 !important;\n}\n\n.emr-enc {\n  --emr-enc-primary: #1976d2;\n  --emr-enc-primary-dark: #0d47a1;\n  --emr-enc-text: #212121;\n  --emr-enc-muted: #616161;\n  --emr-enc-border: #e0e0e0;\n  --emr-enc-surface: #ffffff;\n  max-width: none;\n  margin: 0;\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  color: var(--emr-enc-text);\n  /* Arial is declared here rather than left to inherit from the Materialize\n     overlay, so this section owns its own family. */\n  font-family: var(--emr-font-sans);\n  font-size: 16px;\n}\n\n.emr-enc__pagehead {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.emr-mz-dashboard .emr-enc__title,\n.emr-enc__title {\n  margin: 0;\n  font-size: var(--emr-type-page-title) !important;\n  font-weight: 600;\n  line-height: 1.25;\n  color: var(--emr-enc-text);\n}\n\n.emr-enc__subtitle {\n  margin: 2px 0 0;\n  font-size: var(--emr-type-helper);\n  font-weight: 400;\n  color: var(--emr-enc-muted);\n}\n\n.emr-mz-dashboard .btn.emr-enc__register {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 14px;\n  margin: 0;\n  flex-shrink: 0;\n  background: var(--emr-enc-primary);\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.emr-mz-dashboard .btn.emr-enc__register:hover,\n.emr-mz-dashboard .btn.emr-enc__register:focus {\n  background: var(--emr-enc-primary-dark);\n}\n\n.emr-enc__register-icon {\n  width: 16px;\n  height: 16px;\n}\n\n.emr-enc__filter {\n  max-width: 320px;\n  width: 100%;\n  min-width: 0;\n  margin-bottom: 6px;\n}\n\n.emr-mz-dashboard .emr-enc__filter-trigger,\n.emr-enc__filter-trigger {\n  height: 40px !important;\n  min-height: 40px !important;\n  width: 100% !important;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box !important;\n  border: 1px solid var(--emr-enc-border) !important;\n  border-radius: 0 !important;\n  background: var(--emr-enc-surface) !important;\n  box-shadow: none !important;\n  font-size: var(--emr-type-body) !important;\n  font-weight: 400 !important;\n}\n\n.emr-mz-dashboard .emr-enc__filter-trigger:focus,\n.emr-enc__filter-trigger:focus {\n  border: 1px solid var(--emr-enc-primary) !important;\n  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.18) !important;\n  outline: none;\n}\n\n.emr-enc-select {\n  border-radius: 0 !important;\n  border: 1px solid var(--emr-enc-border, #e0e0e0) !important;\n  background: #fff !important;\n  box-shadow: none !important;\n}\n\n.emr-enc__panel {\n  margin-bottom: 0;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  background: var(--emr-enc-surface);\n  border: 1px solid var(--emr-enc-border);\n  box-shadow: none;\n}\n\n.emr-enc__status-msg,\n.emr-enc__empty {\n  padding: 28px 16px;\n  text-align: center;\n  font-size: 16px;\n  color: var(--emr-enc-muted);\n}\n\n.emr-enc__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.emr-enc__empty-icon {\n  width: 32px;\n  height: 32px;\n  color: #bdbdbd;\n}\n\n.emr-enc__table-wrap {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n\n.emr-mz-dashboard table.emr-enc__table,\n.emr-enc__table {\n  display: table;\n  width: 100%;\n  min-width: 860px;\n  border-collapse: collapse;\n  position: static;\n  font-family: var(--emr-font-sans);\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.emr-mz-dashboard table.emr-enc__table thead,\n.emr-mz-dashboard table.emr-enc__table tbody {\n  display: table-header-group;\n  position: static;\n  float: none;\n  overflow: visible;\n  width: auto;\n}\n\n.emr-mz-dashboard table.emr-enc__table tbody {\n  display: table-row-group;\n}\n\n.emr-mz-dashboard table.emr-enc__table tr {\n  display: table-row;\n}\n\n/*\n * Row geometry lives here on purpose. This selector is (0,2,2) and therefore\n * outranks the `.emr-mz-dashboard .emr-enc__table td` rule below at (0,2,1),\n * so vertical padding and line-height set further down would lose. It also\n * clears Materialize's `.emr-mz-dashboard td, th { padding: 15px 5px }` (0,1,1)\n * without !important.\n *\n * Same accepted clinical density as the patient-chart tables: Arial, 16px text\n * on a 16px line, 20px data rows, 2px vertical cell padding. The 12px\n * horizontal gutter is kept from the existing design — this table declares\n * min-width 860px across seven columns and scrolls, so narrowing the gutter\n * would only crowd the columns.\n */\n.emr-mz-dashboard table.emr-enc__table th,\n.emr-mz-dashboard table.emr-enc__table td {\n  display: table-cell;\n  box-sizing: border-box;\n  height: 20px;\n  max-height: 20px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  font-family: var(--emr-font-sans);\n  font-size: 16px;\n  line-height: 16px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.emr-mz-dashboard .emr-enc__table th {\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--emr-enc-muted);\n  padding: 2px 12px;\n  line-height: 16px;\n  border-bottom: 1px solid var(--emr-enc-border);\n  background: #fafbfc;\n  white-space: nowrap;\n}\n\n.emr-mz-dashboard .emr-enc__table td {\n  font-size: 16px;\n  font-weight: 400;\n  padding: 2px 12px;\n  line-height: 16px;\n  color: var(--emr-enc-text);\n  border-bottom: 1px solid #f0f0f0;\n  vertical-align: middle;\n}\n\n.emr-enc__actions-col {\n  text-align: right;\n}\n\n/* A 20px row leaves a 16px content box once 2px + 2px cell padding is taken,\n   so every in-row chip and action button is sized to exactly 16px. */\n.emr-mz-dashboard a.emr-enc__number,\n.emr-enc__number {\n  display: inline-flex;\n  align-items: center;\n  height: 16px;\n  padding: 0 8px;\n  background: #0b1f33 !important;\n  color: #90caf9 !important;\n  font-size: 16px;\n  line-height: 16px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-decoration: none;\n}\n\n.emr-mz-dashboard a.emr-enc__number:hover,\n.emr-enc__number:hover {\n  background: var(--emr-enc-primary-dark) !important;\n  color: #fff !important;\n}\n\n.emr-enc__patient {\n  font-weight: 600;\n}\n\n/* The start datetime is table data, not chrome, so it takes the 16px standard\n   rather than the metadata band it used before. */\n.emr-enc__start {\n  font-size: 16px;\n  line-height: 16px;\n  color: var(--emr-enc-muted);\n  white-space: nowrap;\n}\n\n/* The DEMO flag keeps --emr-type-micro: emr-typography.css reserves sub-12px\n   for exactly this kind of incidental chrome (\"rulers, demo-data flags\"). Only\n   its box shrinks, so it fits the 16px content box. */\n.emr-enc__demo {\n  display: inline-flex;\n  align-items: center;\n  height: 16px;\n  margin-left: 8px;\n  padding: 0 6px;\n  background: #fff8e1;\n  color: #f9a825;\n  font-size: var(--emr-type-micro);\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  vertical-align: middle;\n}\n\n.emr-enc__status {\n  display: inline-flex;\n  align-items: center;\n  height: 16px;\n  padding: 0 8px;\n  font-size: 16px;\n  line-height: 16px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: capitalize;\n  white-space: nowrap;\n}\n\n.emr-enc__status--planned {\n  background: #e3f2fd;\n  color: #1565c0;\n}\n\n.emr-enc__status--arrived {\n  background: #e8eaf6;\n  color: #3949ab;\n}\n\n.emr-enc__status--triaged {\n  background: #ede7f6;\n  color: #5e35b1;\n}\n\n.emr-enc__status--in-progress {\n  background: #fff8e1;\n  color: #f9a825;\n}\n\n.emr-enc__status--onleave {\n  background: #fff3e0;\n  color: #ef6c00;\n}\n\n.emr-enc__status--finished {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.emr-enc__status--cancelled {\n  background: #eceff1;\n  color: #546e7a;\n}\n\n.emr-enc__row-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 2px;\n  height: 16px;\n}\n\n/*\n * EncounterReadOnlyHint wraps the Edit button in two spans. The inner one is a\n * block containing an inline-flex button, so it builds a line box ~19px tall\n * and would push the row past 20px even though the button itself is 16px.\n * Collapsing the wrappers onto the button keeps the row at the standard without\n * touching the shared hint component.\n */\n.emr-enc__row-actions > span,\n.emr-enc__row-actions > span > span {\n  display: inline-flex;\n  align-items: center;\n  height: 16px;\n}\n\n/* 16x16px in-row action buttons, matching the accepted Past Surgical History /\n   Problem List / Allergies tables. The lucide icons inside are h-4 w-4, so they\n   fill the button exactly. The !important flags here are pre-existing: they\n   clear Materialize's own .btn sizing, not our own cascade. */\n.emr-mz-dashboard .emr-enc-icon-btn {\n  width: 16px !important;\n  height: 16px !important;\n  min-width: 16px !important;\n  min-height: 16px !important;\n  padding: 0 !important;\n  line-height: 1 !important;\n  border-radius: 0 !important;\n  color: var(--emr-enc-primary);\n}\n\n.emr-mz-dashboard .emr-enc-icon-btn--danger {\n  color: #d32f2f;\n}\n\n.emr-enc-dialog {\n  border-radius: 0 !important;\n  border: 1px solid var(--emr-enc-border, #e0e0e0);\n  background: #fff !important;\n  box-shadow: none;\n}\n\n.emr-enc-dialog__delete {\n  background: #d32f2f !important;\n  border-radius: 0 !important;\n}\n\n@media only screen and (max-width: 899px) {\n  .emr-enc__pagehead {\n    flex-wrap: wrap;\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .emr-enc__table-wrap {\n    overflow-x: auto;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .emr-enc__pagehead {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n    margin-bottom: 6px;\n  }\n\n  .emr-mz-dashboard .emr-enc__title,\n  .emr-enc__title {\n    font-size: var(--emr-type-page-title-compact) !important;\n  }\n\n  .emr-mz-dashboard .btn.emr-enc__register {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .emr-enc__filter {\n    max-width: 100%;\n  }\n\n  .emr-mz-dashboard .emr-enc__table th,\n  .emr-mz-dashboard .emr-enc__table td {\n    padding: 2px 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
